import React__default from 'react';
import PropTypes from 'prop-types';
import { getPrimaryPlacement } from '../../utils/popover.js';

const BASE_CLASS = 'nui-popover-arrow';
const Classes = {
  BASE: BASE_CLASS,
  BORDER: `${BASE_CLASS}-border`,
  FILL: `${BASE_CLASS}-fill`
};
const SVG_SHADOW_PATH = 'M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378' + '-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z';
const SVG_ARROW_PATH = 'M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005' + 'c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z';

// additional space between arrow and edge of target
const ARROW_SPACING = 4;
const POPOVER_ARROW_SVG_SIZE = 30;
const TOOLTIP_ARROW_SVG_SIZE = 22;

/** Modifier helper function to compute arrow rotate() transform */
function getArrowAngle(placement) {
  switch (getPrimaryPlacement(placement)) {
    case 'top':
      return -90;
    case 'left':
      return 180;
    case 'bottom':
      return 90;
    default:
      return 0;
  }
}
function getArrowReferenceOffsetStyle(placement) {
  const offset = POPOVER_ARROW_SVG_SIZE / 2 - ARROW_SPACING;
  switch (getPrimaryPlacement(placement)) {
    case 'top':
      return {
        bottom: -offset
      };
    case 'left':
      return {
        right: -offset
      };
    case 'bottom':
      return {
        top: -offset
      };
    default:
      return {
        left: -offset
      };
  }
}
function Arrow({
  arrowProps: {
    ref,
    style
  },
  placement
}) {
  return (
    /*#__PURE__*/
    // data attribute allows popper.js to position the arrow
    React__default.createElement("div", {
      "aria-hidden": true,
      className: Classes.BASE,
      "data-popper-arrow": true,
      ref: ref,
      style: {
        ...style,
        ...getArrowReferenceOffsetStyle(placement)
      }
    }, /*#__PURE__*/React__default.createElement("svg", {
      viewBox: `0 0 ${POPOVER_ARROW_SVG_SIZE} ${POPOVER_ARROW_SVG_SIZE}`,
      style: {
        transform: `rotate(${getArrowAngle(placement)}deg)`
      }
    }, /*#__PURE__*/React__default.createElement("path", {
      className: Classes.BORDER,
      d: SVG_SHADOW_PATH
    }), /*#__PURE__*/React__default.createElement("path", {
      className: Classes.FILL,
      d: SVG_ARROW_PATH
    })))
  );
}
Arrow.propTypes = {
  arrowProps: PropTypes.shape({
    ref: PropTypes.func,
    style: PropTypes.shape({})
  }),
  placement: PropTypes.string
};
Arrow.displayName = 'NuiPopoverArrow';

export { POPOVER_ARROW_SVG_SIZE, TOOLTIP_ARROW_SVG_SIZE, Arrow as default };
